export default [
  {
    path: "ranking",
    name: "Destaques",
    component: () =>
      import(
        /* webpackChunkName: "overview" */ "@/app/modules/ranking/pages/ranking.component.vue"
      ),
  },
];
